/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService
 */

export const fetchRpc = {
  serviceName: 'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'fetch',
  auth: 'app',
  fingerprint: 'mdFQJXEaVZ-OpGJvFnAGn8YHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchAllForUserRpc = {
  serviceName: 'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'fetchAllForUser',
  auth: 'app',
  fingerprint: '70LN6J5vhdkqXAbBKf3l0cYHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};